import React, { Component, createRef } from "react";
import teamAvatars from "./teamAvatars.js";
const config = require("../config.json");

export default class DashboardStanding extends Component {
  constructor(props) {
    super(props);
    this.listRef = createRef();
    this.carouselRef = createRef();
    this.state = {
      isOverflowing: false,
    };
  }

  componentDidMount() {
    this.updateScrollDistance();
    window.addEventListener("resize", this.updateScrollDistance);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateScrollDistance);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.leagues !== this.props.leagues) {
      this.updateScrollDistance();
    }
  }

  updateScrollDistance = () => {
    if (this.listRef.current && this.carouselRef.current) {
      const listHeight = this.listRef.current.clientHeight;
      const carouselHeight = this.carouselRef.current.scrollHeight;
      const isOverflowing = carouselHeight > listHeight;
      const scrollDistance = carouselHeight - listHeight;
      this.carouselRef.current.style.setProperty(
        "--scroll-distance",
        `${-scrollDistance}px`,
      );
      if (this.state.isOverflowing !== isOverflowing) {
        this.setState({ isOverflowing });
      }
    }
  };

  render() {
    let teams = [];
    this.props.leagues.forEach((league) => {
      teams = teams.concat(league.teams);
    });

    const teamSelected = this.props.teamSelected;

    const LiveDot = () => {
      return (
        <svg height="25" width="25" className="blinking">
          <circle cx="12" cy="12" r="6" fill="crimson" />
        </svg>
      );
    };

    return (
      <>
        <div className="standing-card">
          <div className="standing-header">
            <div className="standing-title">
              <LiveDot />
              <h1>Stilling</h1>
            </div>
          </div>

          <div className="standing-list" ref={this.listRef}>
            <div
              className={`standing-carousel ${
                this.state.isOverflowing ? "" : "no-scroll"
              }`}
              ref={this.carouselRef}
            >
              {this.props.rankTeams(teams).map((team, idx) => {
                const avatarSrc =
                  team.avatarId && teamAvatars[team.avatarId]
                    ? teamAvatars[team.avatarId]
                    : null;

                return (
                  <div
                    key={team.id + idx}
                    className={`standing-item ${
                      teamSelected != null &&
                      teamSelected.id == team.id &&
                      "active"
                    }`}
                  >
                    <span className="standing-rank">{idx + 1}</span>
                    <div className="standing-avatar">
                      {avatarSrc ? (
                        <img
                          src={avatarSrc}
                          alt={team.teamName}
                          className="team-avatar-img"
                        />
                      ) : (
                        <div className="avatar-placeholder"></div>
                      )}
                    </div>
                    <span className="standing-team-name">{team.teamName}</span>
                    <span className="standing-points">
                      {team.avgTotalPoints}p
                    </span>
                    <span className="standing-wins">{team.wins}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </>
    );
  }
}
